import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { UserStateService } from '@states/user-state.service';
import { filter, map, startWith } from 'rxjs/operators';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    loggedIn$ = this.userStateService.isLoggedIn$;
    isKioskRoute$ = this.router.events.pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        map(event => event.url.toLowerCase().startsWith('/live-display/kiosk')),
        startWith(window.location.pathname.toLowerCase().startsWith('/live-display/kiosk'))
    );

    constructor(
        private userStateService: UserStateService,
        private router: Router
    ) {
        this.cleanupObsoleteKeys();
    }

    private cleanupObsoleteKeys(): void {
        // One-time cleanup for obsolete localStorage keys from removed Phase 1 test features
        const obsoletePrefixes = [
            'carbon_favourite_sites_user_'
        ];

        try {
            const keysToRemove: string[] = [];
            for (let i = 0; i < localStorage.length; i++) {
                const key = localStorage.key(i);
                if (key && obsoletePrefixes.some(prefix => key.startsWith(prefix))) {
                    keysToRemove.push(key);
                }
            }

            keysToRemove.forEach(key => {
                localStorage.removeItem(key);
                console.log(`[LocalStorage Cleanup] Removed obsolete key: ${key}`);
            });
        } catch (e) {
            console.error('[LocalStorage Cleanup] Failed to run key cleanup:', e);
        }
    }
}
